import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styles/styled';
import { logout } from 'api/authService';
import { LANDING, PROFILE } from 'constants/routes';
import Cookies from 'js-cookie';

interface WalletNavProps {
  onBack: () => void;
}

const WalletNav: React.FC<WalletNavProps> = ({ onBack }) => {
  const navigate = useNavigate();
  const username = localStorage.getItem('username') ?? Cookies.get('username');

  const handleLogout = () => {
    logout();
    navigate(LANDING);
  };

  return (
    <NavContainer>
      <TopRow>
        <Logo>
          <LogoText>TRADING</LogoText>
          <LogoText>BATTLES</LogoText>
        </Logo>
        
        <Username>{username || 'User'}</Username>
        
        <LogoutButton onClick={handleLogout}>
          Logout
          <LogoutIcon>⎋</LogoutIcon>
        </LogoutButton>
      </TopRow>

      <TabsRow>
        <Tab $active={true}>Game</Tab>
        <Tab $active={false} onClick={() => navigate(PROFILE)}>Profile</Tab>
      </TabsRow>

      <BackButton onClick={onBack}>
        ← Back
      </BackButton>
    </NavContainer>
  );
};

const NavContainer = styled.div`
  background: #1a1a1a;
  padding: 16px 20px 0;
  border-bottom: 1px solid #2a2a2a;

  @media (max-width: 720px) {
    padding: 12px 16px 0;
  }
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  @media (max-width: 720px) {
    margin-bottom: 12px;
  }
`;

const Logo = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1;
`;

const LogoText = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #FFFFFF;
  letter-spacing: 0.5px;

  @media (max-width: 720px) {
    font-size: 14px;
  }
`;

const Username = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #EFEFEF;

  @media (max-width: 720px) {
    font-size: 14px;
  }
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: #EFEFEF;
  font-size: 14px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 720px) {
    font-size: 12px;
    padding: 4px 8px;
  }
`;

const LogoutIcon = styled.span`
  font-size: 18px;
  transform: rotate(45deg);
`;

const TabsRow = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 16px;

  @media (max-width: 720px) {
    gap: 16px;
    margin-bottom: 12px;
  }
`;

const Tab = styled.button<{ $active: boolean }>`
  background: ${props => props.$active ? '#1f3a2e' : 'transparent'};
  border: none;
  color: ${props => props.$active ? '#52D381' : '#696969'};
  font-size: 16px;
  font-weight: 600;
  padding: 8px 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${props => props.$active ? '#1f3a2e' : 'rgba(255, 255, 255, 0.05)'};
  }

  @media (max-width: 720px) {
    font-size: 14px;
    padding: 6px 16px;
  }
`;

const BackButton = styled.button`
  background: transparent;
  border: none;
  color: #EFEFEF;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 0 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s ease;

  &:hover {
    color: #52D381;
  }

  @media (max-width: 720px) {
    font-size: 13px;
    padding: 6px 0 10px;
  }
`;

export default WalletNav;
